import * as v from "valibot";
import { attachContext, Control } from "./core";

export type DictionaryItem<T> = { readonly label: string; readonly value: T };
export type DictionaryItems<T> = readonly DictionaryItem<T>[];

export const Dictionary = Symbol("Dictionary");

export const dictionarySchema = <Items extends DictionaryItems<any>>(items: Items) =>
  v.pipe(
    v.custom<Items extends DictionaryItems<infer T> ? T : never>(
      (val) => items.findIndex((it) => it.value == val) != -1,
    ),
    v.brand(Dictionary),
    attachContext(items),
  );

export type DictionaryValue<It extends DictionaryItems<any> = any> = v.InferOutput<
  ReturnType<typeof dictionarySchema<It>>
>;

export const DictionaryControl: Control<DictionaryValue> = function (props) {
  return null;
};
